import { render, staticRenderFns } from "./CompanyPlan.vue?vue&type=template&id=0338df8a&scoped=true&"
import script from "./CompanyPlan.vue?vue&type=script&lang=js&"
export * from "./CompanyPlan.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPlan.vue?vue&type=style&index=0&id=0338df8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338df8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDivider,VIcon})
